import Popover from 'trunks/vue/admin/components/libs/popover.js';
import ChipInput from 'trunks/vue/admin/components/libs/chip_input.js';
import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default Vue.extend({
  components: {
    Popover,
    'chip-input': ChipInput,
    'group-options': GroupOptions,
  },

  template: `
    <Popover position="bottom"
             :caret='false'
             :blockContent='true'
             :manualToggle='true'
             @triggerClicked='triggerClicked'
             ref='popoverVm'>
      <template slot='trigger'>
        <chip-input :chips='selectedItems'
                    placeholder='请选择角色权限'
                    @chipClicked='unselect'
                    ref='chipInput' />
        <i class="slp-caret-down"></i>
      </template>
      <template slot='content'>
        <group-options :groupedOptions='groupedOptions'
                       :multiple='true'
                       @valueChanged='valueChangedFunc'
                       ref='groupedOptionsRef'>
          <template slot='option-item-template' slot-scope='{ option }'>
            <div class='content'>
              <span>{{ option.name }}</span>
            </div>
            <i class='tip' :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
          </template>
        </group-options>
      </template>
    </Popover>
  `,

  props: {
    options: {
      type: Array,
    },
    initialSelectedItems: {
      type: Array,
    },
  },

  data() {
    return {
      selectedItems: this.initialSelectedItems,
    };
  },

  computed: {
    groupedOptions() {
      return [
        {
          allow_clear: true,
          options: this.options,
        },
      ];
    },
  },

  methods: {
    unselect(option) {
      option._selected = !option._selected;
      this.valueChangedFunc(null, option);
    },

    valueChangedFunc(_vm, option) {
      this.selectedItems = option._selected
        ? _.union(this.selectedItems, [option])
        : _.without(this.selectedItems, _.find(this.selectedItems, (item) => item.id === option.id));
      this.$emit('valueChanged', this.selectedItems);
    },

    triggerClicked() {
      this.$refs.popoverVm.open();
    },
  },
});
